import { push } from 'react-router-redux'

import { httpRequest } from 'http'
import { sendErrorNotification } from 'helpers/web_to_client'

import { CHALLENGES } from 'urls'

export const CHALLENGES_REQUEST = 'challenges/REQUEST'
export const CHALLENGES_SUCCESS = 'challenges/SUCCESS'
export const CHALLENGES_ERROR = 'challenges/ERROR'

export const CHALLENGES_LEADERBOARD_REQUEST = 'challenges/leaderboard/REQUEST'
export const CHALLENGES_LEADERBOARD_SUCCESS = 'challenges/leaderboard/SUCCESS'
export const CHALLENGES_LEADERBOARD_ERROR = 'challenges/leaderboard/ERROR'

export const CHALLENGES_NEXT_CHALLENGE_INFO_REQUEST = 'challenges/next_challenge_info/REQUEST'
export const CHALLENGES_NEXT_CHALLENGE_INFO_SUCCESS = 'challenges/next_challenge_info/SUCCESS'
export const CHALLENGES_NEXT_CHALLENGE_INFO_ERROR = 'challenges/next_challenge_info/ERROR'

export const CHALLENGES_PROMO_SHOW = 'challenges/promo/SHOW'
export const CHALLENGES_PROMO_HIDE = 'challenges/promo/HIDE'

export function openChallenges() {
    return push(CHALLENGES)
}

export function startChallengesRequest(spinner) {
    return {
        type: CHALLENGES_REQUEST,
        payload: {
            spinner,
        },
    }
}

export function requestChallengesSuccess(data) {
    return {
        type: CHALLENGES_SUCCESS,
        payload: { ...data },
    }
}

export function requestChallengesError(errorData) {
    sendErrorNotification(errorData)
    return {
        type: CHALLENGES_ERROR,
        payload: errorData,
    }
}

export function requestChallenges(spinner = false, id = null) {
    return async dispatch => {
        dispatch(startChallengesRequest(spinner))

        // Mock of Challenges data for development issues
        if (process.env.API_ENV === 'mock') {
            const mock = require('containers/Challenges/mock.js').default
            if (id === 'dev') {
                return dispatch(requestChallengesSuccess(mock))
            }
        }

        const url = (!id) ? '/game_api/challenges/info' : `/game_api/challenges/info?challenge_id=${id}`
        httpRequest(url)
            .then(
                data => dispatch(requestChallengesSuccess(data)),
                errorData => dispatch(requestChallengesError(errorData))
            )
    }
}


export function startLeaderboardRequest(spinner) {
    return {
        type: CHALLENGES_LEADERBOARD_REQUEST,
        payload: {
            spinner,
        },
    }
}

export function requestLeaderboardSuccess(data) {
    return {
        type: CHALLENGES_LEADERBOARD_SUCCESS,
        payload: { data },
    }
}

export function requestLeaderboardError(errorData) {
    sendErrorNotification(errorData)
    return {
        type: CHALLENGES_LEADERBOARD_ERROR,
        payload: errorData,
    }
}


export function requestLeaderboard(spinner = false, id, challengeName) {
    return async (dispatch, getState) => {
        if (getState().challenges.loading) {
            return
        }
        dispatch(startLeaderboardRequest(spinner))

        // Mock of Leaderboard data for development issues
        if (process.env.API_ENV === 'mock') {
            const mock = require('containers/ChallengeView/mock.js').default
            if (id === 'dev') {
                return dispatch(requestLeaderboardSuccess(mock))
            }
        }

        const url = `/game_api/challenges/${id}/leaderboard/${challengeName}`
        httpRequest(url)
            .then(
                data => dispatch(requestLeaderboardSuccess(data)),
                errorData => dispatch(requestLeaderboardError(errorData))
            )
    }
}

export function startNextChallengeInfoRequest() {
    return {
        type: CHALLENGES_NEXT_CHALLENGE_INFO_REQUEST,
        payload: {},
    }
}

export function requestNextChallengeInfoSuccess(data) {
    return {
        type: CHALLENGES_NEXT_CHALLENGE_INFO_SUCCESS,
        payload: { data },
    }
}

export function requestNextChallengeInfoError(errorData) {
    sendErrorNotification(errorData)
    return {
        type: CHALLENGES_NEXT_CHALLENGE_INFO_ERROR,
        payload: errorData,
    }
}

export function requestNextChallengeInfo() {
    return async dispatch => {
        dispatch(startNextChallengeInfoRequest())
        const url = '/game_api/challenges/next'
        httpRequest(url)
            .then(
                data => dispatch(requestNextChallengeInfoSuccess(data)),
                errorData => dispatch(requestNextChallengeInfoError(errorData))
            )
    }
}

export function showChallengesPromo() {
    return {
        type: CHALLENGES_PROMO_SHOW,
        payload: {},
    }
}

export function hideChallengesPromo() {
    return {
        type: CHALLENGES_PROMO_HIDE,
        payload: {},
    }
}



// WEBPACK FOOTER //
// ./state/actions/challenges.js